module.exports = __webpack_public_path__ + "static/analog-photo-16-3c05694f9dabde6ab5118ea3ff6324a5.jpg";